export default __webpack_public_path__ + "static/Row 3.3_jamiyah-b78a252ddbd89a91c5fd69e0959d5346.jpg";